<!-- Главная страница - Page -->
<template>
  <MarketingLayout @header-c-t-a="handleStartCareer">
    <!-- ВРЕМЕННО: Тест Iconify -->
    <!-- <IconifyTest /> -->

    <!-- Hero секция -->
    <HeroSection @learn-more="scrollToFeatures" @start-career="handleStartCareer" />

    <!-- Секция возможностей -->
    <FeaturesSection :title="featuresTitle" :cta-text="featuresCTA" @cta-click="handleTryApp" />

    <!-- Секция демонстрации приложения -->
    <AppShowcaseSection id="app" @cta-click="handleStartCareer" />

    <!-- Секция площадок -->
    <PlatformsSection />

    <!-- Секция кейсов -->
    <CaseStudiesSection id="cases" @case-click="handleCaseClick" />

    <!-- Секция тарифов -->
    <PricingSection id="pricing" :title="pricingTitle" :plans="pricingPlans" @plan-select="handlePlanSelect" />

    <!-- FAQ секция -->
    <FAQSection id="faq" :title="faqTitle" :items="faqItems" @support-click="handleSupportClick" />
  </MarketingLayout>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import MarketingLayout from '@/components/templates/MarketingLayout.vue'
import HeroSection from '@/components/organisms/HeroSection.vue'
import FeaturesSection from '@/components/organisms/FeaturesSection.vue'
import AppShowcaseSection from '@/components/organisms/AppShowcaseSection.vue'
import PlatformsSection from '@/components/organisms/PlatformsSection.vue'
import CaseStudiesSection from '@/components/organisms/CaseStudiesSection.vue'
import PricingSection from '@/components/organisms/PricingSection.vue'
import FAQSection from '@/components/organisms/FAQSection.vue'

// Hero секция не требует дополнительных данных

// Данные для секции возможностей (из дизайна Figma)
const featuresTitle = 'Твои возможности в одной подписке'
const featuresCTA = 'Попробовать'

// Данные для секции тарифов
const pricingTitle = 'Тарифы'
const pricingPlans = ref([
  {
    name: 'Touch One',
    description: 'для одного артиста',
    price: '500₽',
    period: 'первый месяц',
    originalPrice: '1.500₽',
    badge: '+2 месяца в подарок',
    features: [
      { text: 'Доступ к приложению', included: true },
      { text: 'Личный аккаунт', included: true },
      { text: 'Безлимитная загрузка треков', included: true },
      { text: '95% роялти', included: true },
      { text: 'Личный менеджер', included: true },
      { text: 'Все возможности TOUCH', included: true }
    ],
    buttonText: 'Touch One на месяц',
    buttonTone: 'black' as const,
    popular: false
  },
  {
    name: 'Touch Multi (Label Edition)',
    description: 'любое число артистов',
    price: '4.900₽',
    period: 'мес',
    badge: '+2 месяца в подарок',
    features: [
      { text: 'Доступ к приложению', included: true },
      { text: 'Аккаунт лейбла', included: true },
      { text: 'Безлимитная загрузка треков', included: true },
      { text: '95% роялти', included: true },
      { text: 'Поддержка 24/7', included: true },
      { text: 'Доступ к партнёрским студиям TOUCH', included: true },
      { text: 'Все возможности TOUCH', included: true }
    ],
    buttonText: 'Touch Multi на месяц',
    buttonTone: 'black' as const,
    popular: true
  }
])

// Данные для FAQ
const faqTitle = 'FAQ'
const faqItems = ref([
  {
    question: 'Как быстро загружаются треки на площадки?',
    answer: 'Обычно треки появляются на площадках в течение 24-48 часов после загрузки. Некоторые площадки могут обрабатывать контент быстрее.'
  },
  {
    question: 'Какие площадки поддерживаются?',
    answer: 'Мы работаем с более чем 200 музыкальными площадками, включая Spotify, Apple Music, YouTube Music, Deezer, VK Музыка, Яндекс Музыка и многие другие.'
  },
  {
    question: 'Как работает система роялти?',
    answer: 'Вы получаете 95% от всех доходов с площадок. Выплаты происходят ежемесячно после достижения минимального порога в 1000 рублей.'
  },
  {
    question: 'Можно ли подключить приложение без Telegram?',
    answer: 'Сейчас все работает через Telegram-бота — это быстрый и удобный инструмент для управления релизами. Но мы не останавливаемся. Уже в разработке — наше собственное приложение для App Store и Google Play.',
    open: true
  },
  {
    question: 'Что делать, если нужна помощь по продвижению?',
    answer: 'У нас есть команда маркетинговых специалистов, которые помогут с продвижением вашей музыки. Обратитесь к личному менеджеру через приложение.'
  },
  {
    question: 'Как артисту перейти на тариф лейбла?',
    answer: 'Свяжитесь с поддержкой через приложение или напишите на hello@touch.com. Мы поможем перенести все ваши релизы на новый тариф.'
  }
])

// Обработчики событий
const scrollToFeatures = () => {
  console.log('🎯 [HomePage] Scroll to features called')
  const featuresEl = document.getElementById('features-section')
  console.log('🎯 [HomePage] Features element:', featuresEl)
  if (featuresEl) {
    featuresEl.scrollIntoView({ behavior: 'smooth' })
    console.log('✅ [HomePage] Scrolling to features')
  }
}

const handleStartCareer = () => {
  // Открыть Telegram бот или форму регистрации
  window.open('https://t.me/touch_music_bot', '_blank')
}

const handleTryApp = () => {
  handleStartCareer()
}

const handleCaseClick = (caseStudy: any) => {
  console.log('Case study clicked:', caseStudy.artistName)
  // Логика открытия детальной страницы кейса или модального окна
}

const handlePlanSelect = (plan: any) => {
  console.log('Plan selected:', plan.name)
  handleStartCareer()
}

const handleSupportClick = () => {
  window.open('mailto:hello@touch.com', '_blank')
}
</script>
